import { DataLoadObj, WizConstants } from '@wizeoo/akm-compute-lib';
import { WIZ_COMMAND_METHOD } from '@wizeoo/akm-core-lib';
import { EntityModificationWrapper, EntityModificationCriteria, EntityModificationTrace } from '@wizeoo/akm-message-lib';
import { BASIC_ENTITY_TYPE, EM_RANGE } from '../../model/enums';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { FreedataDataload } from '../../vo/core/freedata.dataload';
import { WorkcomDataload } from '../../vo/workflow/workcom.dataload';


/**
 * Collecte des EMs de suppressions sur BL, BLV, FD, FDV
 * Author LMA
 */
export class DeletedEmsCmd extends WizCommand<EntityModificationWrapper> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }


  public dataLoad: DataLoadObj; // la conf d'appel
  public freedataLoad: FreedataDataload; // la conf d'appel
  public workcomdataLoad: WorkcomDataload;

  /** recherche de suppression sur les Freedatas */
  public findFreedata(freedataLoad: FreedataDataload): DeletedEmsCmd {
    
    this.freedataLoad = freedataLoad;

    const wrapper: EntityModificationWrapper = new EntityModificationWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    wrapper.criteria = new EntityModificationCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
       
    // le range pour définir la portée
    wrapper.criteria.range = EM_RANGE.EM_RANGE_BU;
    
    wrapper.criteria.entityTypes = [BASIC_ENTITY_TYPE.FREEDATA, BASIC_ENTITY_TYPE.FREEDATAVALUE];
    wrapper.criteria.fromRevision = freedataLoad.revisionNumber;

    this.configureRemote(ExternalAPI.DELETED_EMS_API, wrapper);
    return this;
  }

  /** recherche de suppression sur les baselines */
  public findBaseline(dataLoad: DataLoadObj): DeletedEmsCmd {
    
    this.dataLoad = dataLoad;

    const wrapper: EntityModificationWrapper = new EntityModificationWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    wrapper.criteria = new EntityModificationCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.criteria.visionCode = this.model.visionCode;
    // refCode pour limiter la recherche d'EMs au couple level#scen
    wrapper.criteria.refCode = [this.dataLoad.visionStep.level, this.dataLoad.scenario].join(WizConstants.CONTEXT_SEPARATOR);
    // le range pour définir la portée
    wrapper.criteria.range = EM_RANGE.EM_RANGE_VISION;
    
    wrapper.criteria.entityTypes = [BASIC_ENTITY_TYPE.BASELINE, BASIC_ENTITY_TYPE.BASELINE_VALUE] ;
    wrapper.criteria.fromRevision = dataLoad.revisionNumber;

    this.configureRemote(ExternalAPI.DELETED_EMS_API, wrapper);
    return this;
  }

  /** recherche de suppression sur les Workcom */
  public findWorkcom(workcomdataLoad: WorkcomDataload): DeletedEmsCmd {
    
    this.workcomdataLoad = workcomdataLoad;

    const wrapper: EntityModificationWrapper = new EntityModificationWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    wrapper.criteria = new EntityModificationCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.criteria.visionCode = this.model.visionCode;
     wrapper.criteria.refCode = workcomdataLoad.uniqueKey;
       
    // le range pour définir la portée
    wrapper.criteria.range = EM_RANGE.EM_RANGE_VISION;
    
    wrapper.criteria.entityTypes = [BASIC_ENTITY_TYPE.WORKCOM];
    wrapper.criteria.fromRevision = workcomdataLoad.revisionNumber;

    this.configureRemote(ExternalAPI.DELETED_EMS_API, wrapper);
    return this;
  }



  public resolve(): void {
    if (!!this.result?._deletionList) {
      
      // ventilation par classe d'objets
      const deletionMap: Map<number, EntityModificationTrace[]> = new Map();
      this.result._deletionList.forEach((emt: EntityModificationTrace) => {
        if(!deletionMap.has(emt.clas)) {
          deletionMap.set(emt.clas, []);
        }
        deletionMap.get(emt.clas).push(emt);
      });

      [...deletionMap.keys()].forEach((key: number) => { // ventilation par types d'objets
      let traces: EntityModificationTrace[] = deletionMap.get(key);
      switch (key) {
        case BASIC_ENTITY_TYPE.BASELINE:
          traces.forEach((emt: EntityModificationTrace) => {
            let key: string = emt.key;
            if(!this.dataLoad.deletedBaselines) {
              this.dataLoad.deletedBaselines = new Map();
            }
            this.dataLoad.deletedBaselines.set(key, emt);
          });
          // this.baselineDataLoad.deletedBaselines = deletionMap.get(key);
          break;
        case BASIC_ENTITY_TYPE.BASELINE_VALUE:
          traces.forEach((emt: EntityModificationTrace) => {
            let key: string = emt.key;
            if(!this.dataLoad.deletedBaselineValues) {
              this.dataLoad.deletedBaselineValues = new Map();
            }
            if(!this.dataLoad.deletedBaselineValues.has(key)) {
              this.dataLoad.deletedBaselineValues.set(key, []);
            }
            this.dataLoad.deletedBaselineValues.get(key).push(emt);
          });
          break;
        case BASIC_ENTITY_TYPE.FREEDATA:
          this.freedataLoad.deletedFds = deletionMap.get(key);
          break;
        case BASIC_ENTITY_TYPE.FREEDATAVALUE:
          this.freedataLoad.deletedFdvs = deletionMap.get(key);
          break;
        case BASIC_ENTITY_TYPE.WORKCOM:
          this.workcomdataLoad.deletedWorkComs = deletionMap.get(key);
          break;          
      }
      });
    }
  }


}
